import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { judgeArr } from '../shared/functions';
import { message } from 'antd';
const initState = {
    checkOptions: [],
    checkValues: [],
    checkedValues: [],
    checkedOptions: [],
    error: false,
    indeterminate: true,
    checkAll: false,
    emptyName: false,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /**
         * @desc 模糊搜索经销商接口的搜索结果
         */
        searchDealersList(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                // 默认全选样式
                this.RESET_INDETERMINATE();
                const { checkedValues } = rootState.searchDealers;
                // 获取到checkOptions [{label:, value: }]
                const checkOptions = yield this.requestSearch(payload);
                // 处理已经选择的 checkValues
                const resultArr = _dealCheckValues(checkOptions, checkedValues);
                this.SET_STATE({
                    checkOptions,
                    checkValues: resultArr,
                });
                // 全选样式处理
                this._styleAll({ v: resultArr, opts: checkOptions });
            });
        },
        /**
         * @desc 模糊搜索经销商接口
         */
        requestSearch(payload) {
            return __awaiter(this, void 0, void 0, function* () {
                let result = [];
                return Api.user.searchDealers(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    if (judgeArr(data)) {
                        result = data.map((item) => {
                            return {
                                label: item.realname,
                                value: item.useriid,
                            };
                        });
                    }
                    return result;
                }).catch((err) => {
                    console.log(err);
                    return result;
                });
            });
        },
        /**
         * @desc 点击搜索
         */
        onSearch(payload, { update, state, rootState }) {
            const param = { name: payload };
            this.searchDealersList(param);
        },
        /**
         * @desc 选择搜索下的多选框
        */
        onCheckChange(payload, { update, state, rootState }) {
            const { maxChoose, onChange, e } = payload;
            const { checkedOptions, checkedValues, checkValues, checkOptions } = rootState.searchDealers;
            if (maxChoose !== undefined) {
                if (typeof (maxChoose) !== 'number') {
                    console.log('请检查maxChoose类型应为数字类型');
                    return;
                }
                if (e.length > checkValues.length && checkedValues.length >= maxChoose) {
                    message.warning(`最多可以选择${maxChoose}个经销商`);
                    return;
                }
            }
            // 全选样式处理
            this._styleAll({ v: e, opts: checkOptions });
            this.SET_CHECK_VALUES(e);
            let tempObj = {};
            if (e.length > checkValues.length) {
                // 对比选项是增加了
                tempObj = _addOption(checkValues, e, checkOptions, checkedValues, checkedOptions);
            }
            else {
                // 对比选项是删除了
                tempObj = _delOption(checkValues, e, checkedValues, checkedOptions);
            }
            this.SET_STATE({
                checkedOptions: tempObj.resultOp,
                checkedValues: tempObj.oldV2Deal,
            });
            if (onChange) {
                onChange({ values: tempObj.oldV2Deal, options: tempObj.resultOp });
            }
        },
        /**
         * @desc 选择已选经销商
         */
        onCheckedChange(payload, { update, state, rootState }) {
            const { e, onChange } = payload;
            const { checkedOptions, checkValues, checkedValues, checkOptions } = rootState.searchDealers;
            this.SET_CHECKED_VALUES(e);
            // 对比选项是删除了
            if (e.length < checkedValues.length) {
                const { oldV2Deal, resultOp } = _delOption(checkedValues, e, checkValues, checkedOptions);
                this.SET_STATE({
                    checkedOptions: resultOp,
                    checkValues: oldV2Deal,
                });
                // 处理全选样式
                this._styleAll({ v: oldV2Deal, opts: checkOptions });
                if (onChange) {
                    onChange({ values: e, options: resultOp });
                }
            }
        },
        /**
         * @desc 选择 全选本次搜索结果
         */
        onCheckAllChange(payload, { update, state, rootState }) {
            if (payload) {
                // 全选
                const { checkValues, checkOptions, checkedValues, checkedOptions, } = rootState.searchDealers;
                const allV = _checkAll(checkOptions);
                this.SET_CHECKALL(allV);
                const tempObj = _addOption(checkValues, allV, checkOptions, checkedValues, checkedOptions);
                this.SET_STATE({
                    checkedOptions: tempObj.resultOp,
                    checkedValues: tempObj.oldV2Deal,
                });
            }
            else {
                // 全不选
                const { checkValues, checkedValues, checkedOptions, } = rootState.searchDealers;
                const tempObj = _delOption(checkValues, [], checkedValues, checkedOptions);
                this.SET_STATE({
                    checkedOptions: tempObj.resultOp,
                    checkedValues: tempObj.oldV2Deal,
                });
                this.RESET_CHECKALL();
            }
        },
        /**
         * @desc 全选的样式：全选|全不选|其他
         */
        _styleAll(payload, { update, state, rootState }) {
            const { v, opts } = payload;
            const vLen = v.length;
            const optsLen = opts.length;
            if (vLen === optsLen) {
                this.SET_STYLE_CHECKALL();
            }
            if (vLen < optsLen) {
                this.RESET_INDETERMINATE();
            }
            if (vLen === 0) {
                this.RESET_STYLE_CHECKALL();
            }
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
        SET_CHECK_OPTIONS(state, payload) {
            state.checkOptions = payload;
        },
        SET_CHECK_VALUES(state, payload) {
            state.checkValues = payload;
        },
        SET_CHECKED_OPTIONS(state, payload) {
            state.checkedOptions = payload;
        },
        SET_CHECKED_VALUES(state, payload) {
            state.checkedValues = payload;
        },
        SET_ERROR(state) {
            state.error = true;
        },
        RESET_INDETERMINATE(state) {
            state.indeterminate = true;
        },
        SET_CHECKALL(state, payload) {
            state.indeterminate = false;
            state.checkAll = true;
            state.checkValues = payload;
        },
        RESET_CHECKALL(state) {
            state.indeterminate = false;
            state.checkAll = false;
            state.checkValues = [];
        },
        SET_STYLE_CHECKALL(state) {
            state.checkAll = true;
            state.indeterminate = false;
        },
        RESET_STYLE_CHECKALL(state) {
            state.checkAll = false;
            state.indeterminate = false;
        },
        TRUE_EMPTY_NAME(state) {
            state.emptyName = true;
        },
        FALSE_EMPTY_NAME(state) {
            state.emptyName = false;
        },
        set_searchValue(state, payload) {
            state.searchValue = payload;
        },
    },
});
/** 选中选项
 * @property oldV     any[]  选中该选项之前的已选择数组
 *           newV     any[]  选中该选项之后的已选择数组
 *           oldOp    any[]  选中该选项之前的选项数组
 *           oldV2    any[]  选中该选项之前的关联选择组已选择数组
 *           oldOp2   any[]  选中该选项之前的关联选择组选项数组
 * @returns  {oldV2Deal, resultOp} oldV2Deal 关联数组新的已选数组  resultOp 关联数组新的选项数组
 * @argument 找到新增的选项，处理关联数组（即 增加关联数组的选项数组和已选数组）
 */
const _addOption = (oldV, newV, oldOp, oldV2, oldOp2) => {
    let resultOp = [];
    let addVArr = [];
    let addOpArr = [];
    let oldV2Deal = JSON.parse(JSON.stringify(oldV2));
    resultOp = JSON.parse(JSON.stringify(oldOp2));
    addVArr = newV.filter(item => item !== oldV.find(v => (v === item)));
    oldV2Deal = oldV2Deal.concat(addVArr);
    addOpArr = oldOp.filter(v => (addVArr.includes(v.value)));
    resultOp = resultOp.concat(addOpArr);
    return { oldV2Deal, resultOp };
};
/**
 * @desc 删除选项
 * @property oldV     any[]  删除该选项之前的已选择数组
 *           newV     any[]  删除该选项之后的已选择数组
 *           oldV2    any[]  删除该选项之前的关联选择组已选择数组
 *           oldOp    any[]  删除该选项之前的选项数组
 * @returns  {oldV2Deal, resultOp} oldV2Deal 关联数组新的已选数组  resultOp 新的选项数组
 * @argument 找到删除的选项，处理关联数组（即 删除关联数组的选项数组和已选数组）
 */
const _delOption = (oldV, newV, oldV2, oldOp) => {
    let resultOp = [];
    let delVArr = [];
    let oldV2Deal = JSON.parse(JSON.stringify(oldV2));
    delVArr = oldV.filter(item => item !== newV.find(v => (v === item)));
    oldV2Deal = oldV2Deal.filter(v => (!delVArr.includes(v)));
    resultOp = oldOp.filter(v => (!delVArr.includes(v.value)));
    return { oldV2Deal, resultOp };
};
/**
 * @desc 处理搜索结果中已选择的选项
 * 即 已有已选择的经销商，同步至搜索结果中的选项
 * @property options   any[]  搜索结果中的选项数组
 *           v         any[]  已选择的选项数组
 * @returns  resultArr 同步之后的搜索结果选项数组；
 */
const _dealCheckValues = (options, v) => {
    const resultArr = [];
    if (judgeArr(options) && judgeArr(v)) {
        const tempArr = options.map(item => item.value);
        for (const elem of v.values()) {
            if (tempArr.includes(elem)) {
                resultArr.push(elem);
            }
        }
    }
    return resultArr;
};
/**
 * @desc 全选，返回opts里的全部value
 */
const _checkAll = (opts) => {
    const _v = opts.map((item) => {
        return item.value;
    });
    return _v;
};
